import {makeAutoObservable, runInAction} from "mobx";
import {LocStore} from "../utils";
import {axiosHandler} from "../network";

class ShopStore {

    shopInfo = '';
    testShopInfo = '';
    shopT ='';
    spno = '';
    bundleEnabled = false;

    constructor() {
        makeAutoObservable(this)
    }

    set shopSpNo(value) {
        this.shopInfo = value;
    }

    get shopSpNo() {
        return this.shopInfo
    }

    set shopTokenVal(data) {
        this.shopT = data;
    }

    get shopTokenVal() {
        return this.shopT
    }

    getShopSpNo() {
        if (process.env.NODE_ENV === "production") {
            let urls = window.__reqs ?? ""
            console.log(urls, 'url 파싱 전')
            let sp = urls.split('/').filter(item => !!Number(item)).join('')
            console.log({sp})
            this.shopSpNo = sp
        } else {
            this.shopSpNo = 664;
        }
    }

    // 지난 방문에서 확인된 다건 사용 여부. 첫 렌더는 인증 응답 전이라 이 값으로만 매장 성격을 알 수 있다.
    // null = 첫 방문(모름)이며 true/false 와 구분해야 한다 — 모르는 매장은 인증까지 기다려야 하기 때문이다.
    // LocStore 는 falsy 값을 쓰기로 받지 않으므로(값 없으면 읽기) 문자열로 저장한다.
    cachedBundleEnabled = () => {
        const cached = LocStore(`bundleEnabled_${this.spno || this.shopSpNo}`);
        return typeof cached === 'boolean' ? cached : null;
    };

    getAuthToken = async () => {
        this.bundleEnabled = false;
        const spNo = this.spno || this.shopSpNo;
        try {
            const res = await axiosHandler({method: 'POST', url: `/shop/auth/${spNo}`});
            if (res?.data?.resultCode === 200) {
                const {token, bundleEnabled} = res?.data?.data ?? {};
                runInAction(() => {
                    this.shopTokenVal = token;
                    this.bundleEnabled = bundleEnabled === true;
                });
                LocStore(`bundleEnabled_${spNo}`, bundleEnabled === true ? 'true' : 'false');
                LocStore(`shopToken_${spNo}`, token);
            }
        } catch {
            runInAction(() => { this.bundleEnabled = false; });
            throw new Error('매장 인증에 실패했습니다.');
        }
    }


}

let shopStore = new ShopStore();

export default shopStore;
